import { createTheme, alpha } from '@mui/material/styles'
import '@mui/material/styles'
import '@emotion/react'

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#5F3FA5',
      dark: '#231231',
      contrastText: '#FFF'
    },
    secondary: {
      main: '#5F3FA5',
      light: '#5F3FA5'
    },
    background: {
      default: '#efefef'
    },
    action: {
      selected: '#5F3FA5',
      selectedOpacity: 0.5
    }
  }
})

theme.components = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 4, // square corners
        textTransform: 'none', // removes uppercase transformation
        fontWeight: 600,
        '&:hover': { backgroundColor: theme.palette.secondary.light, color: 'white' }
      },
      outlinedPrimary: {
        borderWidth: '2px',
        '&:hover': {
          borderWidth: '2px',
          backgroundColor: theme.palette.secondary.light,
          borderColor: theme.palette.secondary.light
        }
      },
      containedPrimary: {
        borderWidth: '2px',
        '&:hover': {
          borderWidth: '2px',
          backgroundColor: theme.palette.secondary.light,
          borderColor: theme.palette.secondary.light,
        }
      }
    }
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        color: '#7f65b7',
      },
    }
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        padding: '0px'
      },
      colorPrimary: { backgroundColor: theme.palette.primary.dark },
      colorDefault: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black
      }
    }
  },
  MuiFab: {
    styleOverrides: {
      primary: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.primary.contrastText
      }
    }
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        fontSize: 'inherit'
      }
    }
  },
  MuiCheckbox: {
    styleOverrides: {
      checked: {
        color: theme.palette.primary.main + '!important',
      },
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      input: {
        padding: '9px 9px'
      },
      root: {
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: alpha('#000000', 0.87)
        }
      }
    }
  },
  MuiListItem: {
    styleOverrides: {
      root: {
        '&.Mui-focusVisible': {
          backgroundColor: theme.palette.action.selected
        },
        '&.Mui-selected, &.Mui-selected:hover': {
          backgroundColor: alpha(
            theme.palette.action.selected,
            theme.palette.action.selectedOpacity
          )
        }
      }
    }
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: '36px'
      }
    }
  },
  MuiCssBaseline: {
    styleOverrides: {
      '*::-webkit-scrollbar': {
        width: 7,
        height: 7
      },
      '*::-webkit-scrollbar-track': {
        boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.1)'
      },
      '*::-webkit-scrollbar-thumb': {
        backgroundColor: 'darkgrey',
        borderRadius: '4px'
      }
    }
  },
  MuiCollapse: {
    styleOverrides: {
      wrapperInner: {
        width: 'unset'
      }
    }
  },
  MuiBreadcrumbs: {
    styleOverrides: {
      root: { color: 'white !important' },
      li: {
        '& button': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }
      }
    }
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        minWidth: '300px',
        '& .MuiDialogTitle-root': {
          backgroundColor: theme.palette.primary.dark,
          color: theme.palette.primary.contrastText,
          margin: 0,
          paddingLeft: '23px',
          paddingRight: '23px',
          paddingTop: '4px',
          paddingBottom: '4px',
          fontSize: '16px',
          fontWeight: 700,
          '& .MuiTypography-root': {
            '&.MuiTypography-body1': {
              fontSize: '16px',
              fontWeight: 700
            }
          }
        },
        '& .MuiDialogContent-root': {
          padding: '23px !important',
          paddingBottom: '23px',
          '& .MuiDialogContentText-root': {
            margin: '7px 0 7px 0'
          },
          '& .MuiTypography-root': {
            color: 'black',
            fontSize: '14px',
            margin: '0'
          }
        },
        '& .MuiDialogActions-root': {
          paddingTop: '0px',
          paddingRight: '23px',
          paddingBottom: '23px'
        },
        '& .MuiInputLabel-outlined': {
          '&:not(.Mui-focused):not(.MuiFormLabel-filled)': {
            transform: 'translate(10px, 10px)'
          },
        }
      }
    }
  },
  MuiTooltip: {
    styleOverrides: {
      tooltipPlacementBottom: {
        marginBottom: '5px',
        marginTop: '5px',
        backgroundColor: 'rgba(102, 51, 153, 0.87)',
        fontFamily: 'Open Sans',
        fontSize: '12px',
        color: '#FFFFFF',
      }
    }
  }
}

export default theme
